/**
 * A user may lead at most one existing group, and may not be a leader
 * of one group and a member of a different group. Deleted groups do not count.
 */

function groupId(group) {
  return group?.id || group?.group_doc_id || null
}

export function assignmentConflictsForUid(groups, uid, excludeGroupId = null) {
  let leadsOther = false
  let memberOfOther = false

  if (!uid || !Array.isArray(groups)) {
    return { leadsOther, memberOfOther }
  }

  for (const group of groups) {
    const id = groupId(group)
    if (excludeGroupId && id === excludeGroupId) continue
    if (group.leader === uid) leadsOther = true
    if (Array.isArray(group.members) && group.members.includes(uid)) {
      memberOfOther = true
    }
  }

  return { leadsOther, memberOfOther }
}

export function evaluateGroupAssignments(
  groups,
  { leaderUid, memberUids = [], excludeGroupId = null } = {}
) {
  const leaderConflicts = assignmentConflictsForUid(
    groups,
    leaderUid,
    excludeGroupId
  )

  const blockedMemberUids = []
  const seen = new Set()
  for (const uid of memberUids) {
    if (!uid || uid === leaderUid || seen.has(uid)) continue
    seen.add(uid)
    const conflicts = assignmentConflictsForUid(groups, uid, excludeGroupId)
    if (conflicts.leadsOther || conflicts.memberOfOther) {
      blockedMemberUids.push(uid)
    }
  }

  return {
    leaderLeadsOther: leaderConflicts.leadsOther,
    leaderIsMemberElsewhere: leaderConflicts.memberOfOther,
    blockedMemberUids,
  }
}

export async function loadChurchGroups(db, cid) {
  if (!cid) return []
  const snap = await db.collection('groups').where('cid', '==', cid).get()
  return snap.docs.map((doc) => ({
    id: doc.id,
    group_doc_id: doc.id,
    ...doc.data(),
  }))
}
